// Action Types
export const SUBMIT_COMPETITOR_LIST_REQUEST = "SUBMIT_COMPETITOR_LIST_REQUEST";
export const SUBMIT_COMPETITOR_LIST_SUCCESS = "SUBMIT_COMPETITOR_LIST_SUCCESS";
export const SUBMIT_COMPETITOR_LIST_FAILURE = "SUBMIT_COMPETITOR_LIST_FAILURE";

// Action Creators
export const submitCompetitorListRequest = (client) => ({
  type: SUBMIT_COMPETITOR_LIST_REQUEST,
  payload: client,
});

export const submitCompetitorListSuccess = (message) => ({
  type: SUBMIT_COMPETITOR_LIST_SUCCESS,
  payload: message,
});

export const submitCompetitorListFailure = (error) => ({
  type: SUBMIT_COMPETITOR_LIST_FAILURE,
  payload: error,
});
